import { Routes } from '@angular/router';
import { LandingPage } from './landing-page/pages/landing/landing.page';
import { ShellLayout } from './layouts/shell/shell.layout';
import { partnerAuthGuard } from './core/guards/partner-auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: LandingPage
  },
  {
    path: 'app',
    component: ShellLayout,
    canActivate: [partnerAuthGuard],
    children: [
      {
        path: 'overview',
        loadComponent: () =>
          import('./dashboard/pages/overview/overview.page').then((m) => m.OverviewPage)
      },
      {
        path: 'users',
        loadComponent: () =>
          import('./users/users.page').then((m) => m.UsersPage)
      },
      {
        path: 'transactions',
        loadComponent: () =>
          import('./transactions/transactions.page').then((m) => m.TransactionsPage)
      },
      {
        path: 'api-management',
        loadComponent: () =>
          import('./api-management/api-management.page').then((m) => m.ApiManagementPage)
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./settings/settings.page').then((m) => m.SettingsPage)
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./profile/profile.page').then((m) => m.ProfilePage)
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'overview'
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
